var _rect, _text, _text2, _text3, _text4, _text5, _line, _rect2, _text6, _text7, _text8, _line2, _polygon, _rect3, _text9, _text10, _text11, _line3, _polygon2, _rect4, _text12, _text13, _text14, _text15, _line4, _polygon3, _rect5, _text16, _text17, _text18, _text19, _line5, _polygon4, _rect6, _text20, _text21, _text22, _rect7, _text23;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSessionNativeArch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 420",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "boxGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#1a1a1a",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#111111",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "accentGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#DCCA87",
      stopOpacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#DCCA87",
      stopOpacity: 0.4
    }
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 420,
    rx: 8,
    fill: "#0C0C0C",
    stroke: "#DCCA87",
    strokeOpacity: 0.15,
    strokeWidth: 1
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 36,
    textAnchor: "middle",
    fontFamily: "monospace",
    fontSize: 11,
    fill: "#DCCA87",
    letterSpacing: 2,
    opacity: 0.7
  }, "SESSION-NATIVE RUNTIME INTELLIGENCE")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 72,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 10,
    fill: "#AAAAAA",
    letterSpacing: 1
  }, "INSTRUMENTATION")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 330,
    y: 72,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 10,
    fill: "#AAAAAA",
    letterSpacing: 1
  }, "INGESTION")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 540,
    y: 72,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 10,
    fill: "#AAAAAA",
    letterSpacing: 1
  }, "INTELLIGENCE")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 710,
    y: 72,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 10,
    fill: "#AAAAAA",
    letterSpacing: 1
  }, "OUTPUT")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 82,
    x2: 760,
    y2: 82,
    stroke: "#DCCA87",
    strokeOpacity: 0.12,
    strokeWidth: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 110,
    width: 120,
    height: 70,
    rx: 4,
    fill: "url(#boxGrad)",
    stroke: "#DCCA87",
    strokeOpacity: 0.3,
    strokeWidth: 1
  })), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 138,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 13,
    fill: "#FFFFFF",
    fontWeight: 500
  }, "SDK")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 158,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 10,
    fill: "#AAAAAA"
  }, "2-line attach")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 172,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 10,
    fill: "#AAAAAA"
  }, "zero-config")), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 180,
    y1: 145,
    x2: 230,
    y2: 145,
    stroke: "#DCCA87",
    strokeOpacity: 0.5,
    strokeWidth: 1
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "230,141 238,145 230,149",
    fill: "#DCCA87",
    fillOpacity: 0.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 110,
    width: 140,
    height: 70,
    rx: 4,
    fill: "url(#boxGrad)",
    stroke: "#DCCA87",
    strokeOpacity: 0.3,
    strokeWidth: 1
  })), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 310,
    y: 138,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 13,
    fill: "#FFFFFF",
    fontWeight: 500
  }, "Event Stream")), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 310,
    y: 158,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 10,
    fill: "#AAAAAA"
  }, "ordered, causally-linked")), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 310,
    y: 172,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 10,
    fill: "#AAAAAA"
  }, "session-scoped")), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 380,
    y1: 145,
    x2: 430,
    y2: 145,
    stroke: "#DCCA87",
    strokeOpacity: 0.5,
    strokeWidth: 1
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "430,141 438,145 430,149",
    fill: "#DCCA87",
    fillOpacity: 0.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 440,
    y: 100,
    width: 160,
    height: 90,
    rx: 4,
    fill: "url(#boxGrad)",
    stroke: "#DCCA87",
    strokeOpacity: 0.3,
    strokeWidth: 1
  })), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 520,
    y: 128,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 13,
    fill: "#FFFFFF",
    fontWeight: 500
  }, "Execution Graph")), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 520,
    y: 148,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 10,
    fill: "#AAAAAA"
  }, "causal DAG construction")), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 520,
    y: 164,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 10,
    fill: "#AAAAAA"
  }, "cycle detection")), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    x: 520,
    y: 180,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 10,
    fill: "#AAAAAA"
  }, "lineage tracking")), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 520,
    y1: 190,
    x2: 520,
    y2: 230,
    stroke: "#DCCA87",
    strokeOpacity: 0.5,
    strokeWidth: 1
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "516,230 520,238 524,230",
    fill: "#DCCA87",
    fillOpacity: 0.5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 440,
    y: 240,
    width: 160,
    height: 100,
    rx: 4,
    fill: "url(#boxGrad)",
    stroke: "#DCCA87",
    strokeOpacity: 0.4,
    strokeWidth: 1
  })), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    x: 520,
    y: 268,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 13,
    fill: "#FFFFFF",
    fontWeight: 500
  }, "Analysis Engines")), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    x: 520,
    y: 290,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 10,
    fill: "#DCCA87"
  }, "Anomaly Detection")), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    x: 520,
    y: 306,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 10,
    fill: "#DCCA87"
  }, "Cost Attribution")), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    x: 520,
    y: 322,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 10,
    fill: "#DCCA87"
  }, "Drift Identification")), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 600,
    y1: 290,
    x2: 640,
    y2: 290,
    stroke: "#DCCA87",
    strokeOpacity: 0.5,
    strokeWidth: 1
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "640,286 648,290 640,294",
    fill: "#DCCA87",
    fillOpacity: 0.5
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 650,
    y: 250,
    width: 120,
    height: 80,
    rx: 4,
    fill: "url(#boxGrad)",
    stroke: "#DCCA87",
    strokeOpacity: 0.5,
    strokeWidth: 1.5
  })), _text20 || (_text20 = /*#__PURE__*/React.createElement("text", {
    x: 710,
    y: 280,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 13,
    fill: "#FFFFFF",
    fontWeight: 500
  }, "Causal")), _text21 || (_text21 = /*#__PURE__*/React.createElement("text", {
    x: 710,
    y: 298,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 13,
    fill: "#FFFFFF",
    fontWeight: 500
  }, "Explanation")), _text22 || (_text22 = /*#__PURE__*/React.createElement("text", {
    x: 710,
    y: 320,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 10,
    fill: "#AAAAAA"
  }, "WHY, not just WHAT")), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 390,
    width: 720,
    height: 20,
    rx: 3,
    fill: "none",
    stroke: "#DCCA87",
    strokeOpacity: 0.2,
    strokeWidth: 1,
    strokeDasharray: "4,4"
  })), _text23 || (_text23 = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 404,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 9,
    fill: "#DCCA87",
    opacity: 0.5
  }, "SESSION BOUNDARY \u2014 all events within a single agent session, not individual traces")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSessionNativeArch);
export default __webpack_public_path__ + "static/media/session-native-arch.32b7391a1fe42c9420ed8c439ab2a849.svg";
export { ForwardRef as ReactComponent };